import DOMPurify from 'dompurify';

export const RICH_TEXT_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    'strong',
    'em',
    'u',
    's',
    'a',
    'ul',
    'ol',
    'li',
    'blockquote',
  ],
  ALLOWED_ATTR: ['href', 'class', 'data-size'],
  ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|xxx):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  FORBID_TAGS: ['style', 'script', 'iframe', 'img', 'svg'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick'],
  USE_PROFILES: {
    html: true,
    svg: false,
    svgFilters: false,
    mathMl: false,
  },
  RETURN_DOM_FRAGMENT: false,
  RETURN_DOM: false,
  SANITIZE_DOM: true,
  KEEP_CONTENT: true,
};

export const sanitizeRichText = (content: string) => DOMPurify.sanitize(content, RICH_TEXT_SANITIZE_CONFIG);

export const sanitizeInput = (input: string) => {
  // Remove zero-width characters and other invisible formatting
  return input.replace(/[\u200B-\u200D\uFEFF]/g, '');
};

export const validateContent = (html: string) => {
  // Check for unclosed tags
  const div = document.createElement('div');
  div.innerHTML = html;
  const normalized = div.innerHTML;
  if (html !== normalized) {
    return false;
  }
  return true;
};

/* We additionally sanitize the content here so we can show an error message if the URL is being blocked by our purifier */
export const validateUrl = (url: string) => {
  const sanitized = DOMPurify.sanitize(`<a href="${url}">test</a>`, {
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href'],
    ALLOWED_URI_REGEXP: RICH_TEXT_SANITIZE_CONFIG.ALLOWED_URI_REGEXP,
  });
  const testElement = document.createElement('div');
  testElement.innerHTML = sanitized;
  const resultHref = testElement.querySelector('a')?.getAttribute('href');
  if (!resultHref || resultHref !== url) {
    return 'URL contains unsafe content and will be rejected';
  }

  return '';
};
